import React, { useState } from 'react'
import { TabPanel } from 'react-tabs'
import { arrayOf, string } from 'prop-types'

import {
  VehicleShowcaseStyled,
  VehicleShowcaseNavStyled,
  VehicleShowcaseNavButtonStyled,
  VehicleShowcaseTabListStyled,
  VehicleShowcaseTabStyled,
  VehicleShowcaseTabsStyled,
} from './styles'
import VehicleShowcase360 from '../VehicleShowcase360'
import VehicleShowcasePanoramaWrapper from '../VehicleShowcasePanoramaWrapper'
import ImageGallery from '../ImageGallery'
import { Typo5 } from '../Typography'
import NAVIGATION from '../../constants/navigation'

const VehicleShowcase = (
  {
    assets360,
    poster,
    interiorImage,
    sliderImages = [],
  }
) => {
  const [mode, setMode] = useState(0)
  const changeMode = addAmount => () => setMode(mode + addAmount)
  const navigationItems = interiorImage
    ? Object.values(NAVIGATION)
    : [NAVIGATION.EXTERIOR, NAVIGATION.IMAGES]
  const navigationLength = navigationItems.length
  const slidesLength = (navigationLength - 1) + sliderImages.length

  return (
    <VehicleShowcaseStyled>
      <VehicleShowcaseTabsStyled
        selectedIndex={mode > (navigationLength - 1)
          ? (navigationLength - 1) : mode}
        onSelect={setMode}
      >
        <VehicleShowcaseNavStyled>
          <VehicleShowcaseTabListStyled>
            {navigationItems.map(item => (
              <VehicleShowcaseTabStyled
                key={item}
              >
                <VehicleShowcaseNavButtonStyled>
                  <Typo5>{item}</Typo5>
                </VehicleShowcaseNavButtonStyled>
              </VehicleShowcaseTabStyled>
            ))}
          </VehicleShowcaseTabListStyled>
        </VehicleShowcaseNavStyled>
        <TabPanel>
          <VehicleShowcase360
            load
            assets={assets360}
            poster={poster}
            slidesLength={slidesLength}
            activeIndex={mode}
            onLeftClick={changeMode(-1)}
            onRightClick={changeMode(1)}
          />
        </TabPanel>
        {interiorImage !== null && (
          <TabPanel>
            <VehicleShowcasePanoramaWrapper
              image={interiorImage}
              slidesLength={slidesLength}
              activeIndex={mode}
              onLeftClick={changeMode(-1)}
              onRightClick={changeMode(1)}
            />
          </TabPanel>
        )}
        <TabPanel>
          <ImageGallery
            images={sliderImages}
            slidesLength={slidesLength}
            onPrevClick={index => index === 0 && setMode(interiorImage ? 1 : 0)}
            slideNumberDisplayOffset={interiorImage ? 2 : 1}
          />
        </TabPanel>
      </VehicleShowcaseTabsStyled>
    </VehicleShowcaseStyled>
  )
}

VehicleShowcase.defaultProps = {
  interiorImage: '',
}

VehicleShowcase.propTypes = {
  poster: string.isRequired,
  interiorImage: string,
  assets360: arrayOf(string).isRequired,
  sliderImages: arrayOf(string).isRequired,
}

export default VehicleShowcase
